import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createSlots as _createSlots, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8aa64582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = {
  key: 0,
  src: "assets/mkUltra.svg",
  style: {"width":"100%","height":"auto"}
}
const _hoisted_4 = {
  key: 1,
  src: "assets/mk_mini_logo.svg",
  style: {"width":"40px","height":"auto"}
}
const _hoisted_5 = { class: "ms-5 text-gray-01 text-sm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-01" }, "Relatórios", -1))
const _hoisted_7 = { class: "text-gray-01 text-sm" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ms-5 text-gray-01 text-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ms-5 text-gray-01 text-sm active" }, "Meus Dados", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ms-5 text-gray-01 text-sm active" }, "Logout", -1))

import { withDefaults, onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import {
  LogoutIcon,
  ArchiveBookIcon,
  HouseIcon,
  Element3Icon,
  CompanyIcon,
  PeopleIcon,
  MonitorMobbileIcon,
  ProfileIcon,
  GroupIcon,
  CpuIcon,
} from '../atoms';
import Sidebar from '@/store/modules/sideBar';
import { Authentication } from '@/store';
import router, { routes } from '@/router';
import axios from 'axios';
import { IMenuItem } from '@/types';
import * as icons from '@/components/atoms';
interface IProps {
  title?: string;
  menus: IMenuItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsNavigation',
  props: {
    title: null,
    menus: null
  },
  setup(__props: any) {

const props = __props as { title?: string, menus: IMenuItem[] };

const { links, showNavigation } = Sidebar();
const version = ref<string>('');

const admins = ref<any[]>([
  ['Management', 'mdi-account-multiple-outline'],
  ['Settings', 'mdi-cog-outline'],
]);

const open = ref<boolean>(false);

const route = useRoute();

const mapComp = ref<any[]>([]);

const drawer = ref<boolean>(true);
const rail = ref<boolean>(true);

function handleLogout() {
  Authentication.actions.logout();
  router.push({ name: 'Login' });
}
function dbClick() {
  router.push({ name: 'Mk' });
}

const relatorios = computed(() => {
  return props.menus.filter((f) => f.group == 1);
});

const menusComputed = computed(() => {
  return props.menus.filter((f) => f.group == 0);
});
onMounted(() => {
  for (const iterator of routes) {
    if (iterator.meta?.icon) {
      const meta = iterator.meta?.icon;
      mapComp.value[String(meta)] = icons[String(meta)];
    }
  }

  fetch('version')
    .then((response) => response.text())
    .then((csvString) => {
      //Split the csv into rows
      console.log(csvString);
      version.value = csvString;
    });
});

return (_ctx: any,_cache: any) => {
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    permanent: "",
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
    rail: rail.value,
    onClick: _cache[2] || (_cache[2] = ($event: any) => (rail.value = false)),
    class: "bg-gray-06",
    width: 300
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_list, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "mb-12 area-logo",
                onDblclick: dbClick
              }, [
                (!rail.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : _createCommentVNode("", true),
                (rail.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : _createCommentVNode("", true)
              ], 32)
            ]),
            _: 1
          }),
          _createVNode(_component_v_app_bar_nav_icon, {
            class: "d-flex flex-column",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (rail.value = !rail.value), ["stop"]))
          }),
          _createVNode(_component_v_list, {
            density: "compact",
            nav: "",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menusComputed), (menu, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: String(index)
                }, [
                  _createVNode(_component_v_list_item, {
                    class: "py-5",
                    to: menu.path,
                    "active-color": "var(--primary-)"
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(menu.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, [
                    (menu.icon)
                      ? {
                          name: "prepend",
                          fn: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(mapComp.value[menu.icon]), {
                              color: _unref(route).path === menu.path ? 'var(--primary-)' : ''
                            }, null, 8, ["color"]))
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["to"]),
                  (menu.divider)
                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (_unref(relatorios).length && !rail.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 0,
                    value: "Relatórios"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        class: "text-gray-01",
                        style: {"font-weight":"500","letter-spacing":"normal","line-height":"1rem"}
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { align: "center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArchiveBookIcon), { class: "me-4 text-gray-01" })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "9" }, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relatorios), (menu, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: String(index)
                        }, [
                          _createVNode(_component_v_list_item, {
                            class: "py-5",
                            to: menu.path,
                            "active-color": "var(--primary-)"
                          }, _createSlots({
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_7, _toDisplayString(menu.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, [
                            (menu.icon)
                              ? {
                                  name: "prepend",
                                  fn: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(mapComp.value[menu.icon]), {
                                      color: _unref(route).path === menu.path ? 'var(--primary-)' : ''
                                    }, null, 8, ["color"]))
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1032, ["to"]),
                          (menu.divider)
                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_list, {
          density: "compact",
          nav: "",
          class: "pa-0 scrollVisible"
        }, {
          default: _withCtx(() => [
            (!rail.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, { class: "py-5 area-sair" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_9, "Versão: " + _toDisplayString(version.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_list_item, {
              to: "/profile",
              class: "area-sair"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_unref(ProfileIcon), { class: "me-1" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_list_item, {
              class: "area-sair",
              onClick: handleLogout
            }, {
              prepend: _withCtx(() => [
                _createVNode(_unref(LogoutIcon), { class: "me-1" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "rail"]))
}
}

})